import { getDataFromServer, putDataToServer } from '../../../util';

class ConfigurationModule {
  constructor(baseURL, httpHeaders) {
    this.baseURL = baseURL;
    this.httpHeaders = httpHeaders;
  }

  fetchTRMConfigurations = async () => {
    const url = `${this.baseURL}/configurations`;
    return await getDataFromServer(url, this.httpHeaders);
  };

  updateTRMConfigurations = async (payload) => {
    const { data } = payload;
    const url = `${this.baseURL}/configurations`;
    return await putDataToServer(url, this.httpHeaders, {}, data);
  };
}

export default ConfigurationModule;
